import type { TFunction } from "i18next";
import U2000DeleteRecordDialog from "../../../../../u2000Core/components/dialog/U2000DeleteRecordDialog";
import type { U3121Employee } from "../../../../U3121Service";
import type { U3121SubProjectTimesheetAccessHandlerReturn } from "./U3121SubProjectTimesheetAccessHandlers";

function displayEmployeeLabel(row: U3121Employee): string {
  if (!row) return "";
  const firstName = row.firstName ?? "";
  const lastName = row.lastName ?? "";
  const code = row.codeEmployee ?? "";
  const name = [firstName, lastName].filter(Boolean).join(" ").trim();
  return code ? `${name} (${code})` : name || row.id;
}

interface U3121SubProjectTimesheetAccessDeleteDlgProps {
  handler: U3121SubProjectTimesheetAccessHandlerReturn;
  t: TFunction;
  NS: string;
}

function U3121SubProjectTimesheetAccessDeleteDlg({ handler, t, NS }: U3121SubProjectTimesheetAccessDeleteDlgProps) {
  if (!handler.isDeleteDialogOpen) return null;

  const rowsToDelete = handler.gridStateHandlers.getSelectedRows().filter((r) => r.source === "subproject");

  return (
    <U2000DeleteRecordDialog isOpen={handler.isDeleteDialogOpen} onClose={handler.onDlgDeleteClose} title={t("lblTimesheetAccess", { ns: NS })}>
      <p className="mb-4">
        {t("msgDeleteTimesheetAccess", {
          count: rowsToDelete.length,
          ns: NS,
        })}
      </p>
      <div className="mt-2 flex flex-wrap justify-center gap-x-2">
        {rowsToDelete.map((row, index, array) => (
          <span key={row.id} className="inline-block text-gray-800">
            {displayEmployeeLabel(row)}
            {index < array.length - 1 && ", "}
          </span>
        ))}
      </div>
    </U2000DeleteRecordDialog>
  );
}

export default U3121SubProjectTimesheetAccessDeleteDlg;
